import React from 'react';
import { BusyIndicator } from "@ui5/webcomponents-react/dist/BusyIndicator";
import { BusyIndicatorSize } from "@ui5/webcomponents-react/dist/BusyIndicatorSize";
const DefaultStyles = {
  background: 'transparent',
};
export default props => {
  return (
    <BusyIndicator
      {...props}
      size={props.hasOwnProperty('size') ? props.size : BusyIndicatorSize.Large}
      active={props.hasOwnProperty('active') ? props.active : true}
      style={{ ...DefaultStyles, ...(props.customStyles || {}) }}
      data-testid="spinner"
    />
  );
};
